import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';

export class LivestreamApi {
  private apiUrl = environment.API_URL + '/livestream';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  endLive(roomId: string) {
    return this.http.get<any>(this.apiUrl + `/lives/${roomId}/end`).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res.success;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}